// extracted by mini-css-extract-plugin
export var attribution = "_8u-4";
export var authorName = "_8u-5";
export var quote = "_8u-3";
export var testimonial = "_8u-2";
export var trustedBy = "_8u-0";
export var trustedByLabel = "_8u-1";